import React, { createContext, useContext, useEffect, useState } from "react";
import useVendorAuthContext from "./vendor/azure/hooks/useVendorAuthContext";
import VendorAuthProps from "./vendor/azure/types/vendor";
import useLoginMachine from "../../context/customize/login/use";
import { app } from "../../context/global/data";

type AuthMachine = {
	state: any;
	send: any;
	service: any;
};
export interface AuthContextProps extends VendorAuthProps {
	machine: AuthMachine;
	validPitcherEmail: boolean;
	setValidPitcherEmail: (value: boolean) => void;
	backendSessionReady: boolean;
}

const initialData = {};

const AuthContext = createContext(initialData as AuthContextProps);

export const AuthControllerProvider = (props: any) => {
	const vendor = useVendorAuthContext();
	const [state, send, service] = useLoginMachine(vendor);
	const [validPitcherEmail, setValidPitcherEmail] = useState(true);
	const [backendSessionReady, setBackendSessionReady] = useState(false);

	// Create backend session when Azure AD authentication succeeds
	useEffect(() => {
		const isAuthenticated = vendor.instance?.isAuthenticated;
		const idToken = vendor.instance?.user?.id_token;

		if (isAuthenticated && idToken && !backendSessionReady) {
			const loginUrl = `${app.url}auth/login`;
			fetch(loginUrl, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				credentials: "include",
				body: JSON.stringify({ token: idToken }),
			})
				.then(async (response) => {
					if (response.ok) {
						setBackendSessionReady(true);
					} else {
						const body = await response.json().catch(() => ({}));
						console.error(
							"Backend session creation failed:",
							response.status,
							body.detail || body.error,
						);
					}
				})
				.catch((err) => {
					console.error("Backend session creation error:", err);
				});
		}

		if (!isAuthenticated) {
			setBackendSessionReady(false);
		}
	}, [vendor.instance?.isAuthenticated, vendor.instance?.user?.id_token, backendSessionReady]);

	return (
		<AuthContext.Provider
			value={{
				...vendor,
				validPitcherEmail,
				setValidPitcherEmail,
				backendSessionReady,
				machine: { state, send, service },
			}}
		>
			{props.children}
		</AuthContext.Provider>
	);
};

export const useAuthContext = () => useContext(AuthContext);
